import { apiFetch } from "@/auth/apiClient";

export type PermissionKey =
  | "create_course"
  | "create_exam"
  | "edit_course"
  | "manage_students"
  | "moderate_community"
  | "view_analytics"
  | "manage_certificates";

export const PERMISSION_KEYS: PermissionKey[] = [
  "create_course",
  "create_exam",
  "edit_course",
  "manage_students",
  "moderate_community",
  "view_analytics",
  "manage_certificates",
];

export type AdminUserWithPermissions = {
  id: number;
  email: string;
  role: "STUDENT" | "TEACHER" | "SYSTEM_ADMIN";
  permissions: Record<PermissionKey, boolean>;
};

export type AdminUsersWithPermissionsResponse = {
  data: AdminUserWithPermissions[];
  count: number;
  page: number;
  totalPages: number;
};

export async function getAdminUsersWithPermissions(params: {
  page?: number;
  limit?: number;
} = {}): Promise<AdminUsersWithPermissionsResponse> {
  const page = params.page ?? 1;
  const limit = params.limit ?? 50;
  const qs = new URLSearchParams({ page: String(page), limit: String(limit) });
  return apiFetch<AdminUsersWithPermissionsResponse>(
    `/auth/user/permissions?${qs.toString()}`,
    { method: "GET" }
  );
}

export async function updateUserRole(
  userId: number,
  role: "STUDENT" | "TEACHER" | "SYSTEM_ADMIN"
): Promise<{ success: true }> {
  return apiFetch<{ success: true }>(`/auth/user/${userId}/role`, {
    method: "PATCH",
    json: { role },
  });
}

export async function updateUserPermissions(
  userId: number,
  permissions: Record<PermissionKey, boolean>
): Promise<{ success: true }> {
  return apiFetch<{ success: true }>(`/auth/user/${userId}/permissions`, {
    method: "PATCH",
    json: { permissions },
  });
}

export async function getMyPermissions(): Promise<Record<PermissionKey, boolean>> {
  return apiFetch<Record<PermissionKey, boolean>>(`/auth/user/me/permissions`, {
    method: "GET",
  });
}

